import React, { FC, useCallback, useEffect, useState } from 'react';

import { useWizard, WizardStep } from '../../../contexts/WizardContext';

import Layout from '../../Layout';
import SelectBox from '../../shared/select-boxes/SelectBox';
import VideoComponent from '../../shared/VideoComponent';
import ExistingCompanyPopup from './ExistingCompanyPopup';
import ButtonBack from '../../shared/buttonComponents/ButtonBack';
import { useHistory } from 'react-router-dom';

export const CompanyTypePage: FC = () => {
  const {
    changeStep,
    updateStepData
  } = useWizard();

  const [showPopup, setShowPopup] = useState(false);

  const handleSelect = useCallback((companyYears) => {
    updateStepData({
      companyType: 'Existing Company',
      companyYears
    });
    setShowPopup(false);
    changeStep(WizardStep.EXPENDED_MONTHLY_VOLUME);
  }, [changeStep, updateStepData, setShowPopup]);

  const handleSelectStartUp = useCallback(() => {
    updateStepData({
      companyType: 'Startup'
    });
    changeStep(WizardStep.EXPENDED_MONTHLY_VOLUME);
  }, [updateStepData, changeStep]);

  let history = useHistory();

  useEffect(() => {

    return () => {
      if (history.action === "POP") {

        changeStep(WizardStep.LICENCE_TYPE)
      }
    }
  })

  return (
    <Layout>

      <div className="company-type-page-container">
        {showPopup && (
          <ExistingCompanyPopup
            onClose={() => setShowPopup(false)}
            onSubmit={handleSelect}
          />
        )}

        <div className="company-type-page-right-mobile">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/company-type.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/company-type.png`}
          />
        </div>

        <div className="company-type-page-left">
          <div className="secondary-title">Thanks... Next up,</div>
          <div className="main-title">Are you a?</div>

          <div className="company-type-page-list">
            <SelectBox onClick={handleSelectStartUp} icon='startup' title="Startup"/>

            <div className="company-type-page-or">
              <div className="company-type-page-or-top"/>
              <div className="company-type-page-or-text">OR</div>
              <div className="company-type-page-or-bottom"/>
            </div>

            <SelectBox onClick={() => setShowPopup(true)} icon='existing-company' title="Existing Company"/>
          </div>
        </div>

        <div className='company-type-page-button'>
          <ButtonBack
            disabled={false}
            onClick={() => changeStep(WizardStep.LICENCE_TYPE)}
            title="Back"
          />
        </div>

        <div className="company-type-page-right">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/company-type.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/company-type.png`}
          />
        </div>

      </div>
    </Layout>
  );
};
